<template>
  <section
    aria-label="서비스 선택"
    class="selector-page"
    data-testid="entry-selector"
  >
    <div class="selector-container">
      <!-- Top Logo -->
      <img
        src="/images/tble_logo2.svg"
        alt="티블"
        class="selector-logo"
      />

      <!-- Title & Subtitle -->
      <div class="selector-header">
        <p class="selector-badge">CHOOSE YOUR SERVICE</p>
        <h1 class="selector-title">어디로 이동하시겠어요?</h1>
        <p class="selector-desc">
          티블의 두 가지 서비스 중 원하시는 곳을 선택해주세요.
        </p>
      </div>

      <!-- Cards Grid -->
      <div class="selector-cards">
        <!-- Card 1: 티블 체험단 (For Creators) -->
        <a
          href="https://tble.kr/?utm_source=tblebiz&utm_medium=referral&utm_campaign=biz_to_experience&utm_content=selector_card"
          class="selector-card selector-card--creators"
          data-testid="selector-card-experience"
          @click="trackExperience"
        >
          <div class="selector-card__icon selector-card__icon--white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"
              />
              <path d="M20 2v4" />
              <path d="M22 4h-4" />
              <circle cx="4" cy="20" r="2" />
            </svg>
          </div>
          <span class="selector-card__subtitle selector-card__subtitle--gray"
            >FOR CREATORS</span
          >
          <h2 class="selector-card__title">티블 체험단</h2>
          <p class="selector-card__desc">
            리뷰어와 인플루언서를 위한 체험단 참여 서비스입니다.
          </p>
          <ul class="selector-card__bullets">
            <li>
              <span class="bullet-dot"></span>
              체험단 캠페인 신청
            </li>
            <li>
              <span class="bullet-dot"></span>
              블로그·인스타 리뷰 활동
            </li>
            <li>
              <span class="bullet-dot"></span>
              tble.kr로 이동
            </li>
          </ul>
          <span class="selector-card__btn selector-card__btn--outline">
            체험단 바로가기
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M15 3h6v6" />
              <path d="M10 14 21 3" />
              <path
                d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
              />
            </svg>
          </span>
        </a>

        <!-- Card 2: 티블비즈 광고주 (For Advertisers) - Highlighted -->
        <button
          type="button"
          class="selector-card selector-card--advertiser"
          data-testid="selector-card-advertiser"
          @click="goToTbleBiz"
        >
          <div class="selector-card__icon selector-card__icon--gold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"
              />
              <path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" />
              <path d="M8 6v8" />
            </svg>
          </div>
          <span class="selector-card__subtitle selector-card__subtitle--gold"
            >FOR ADVERTISERS</span
          >
          <h2 class="selector-card__title">티블비즈 광고주</h2>
          <p class="selector-card__desc">
            리뷰 마케팅을 운영하려는 광고주 전용 상담 랜딩입니다.
          </p>
          <ul class="selector-card__bullets">
            <li>
              <span class="bullet-dot"></span>
              다채널 리뷰 마케팅 상담
            </li>
            <li>
              <span class="bullet-dot"></span>
              광고주 대시보드 기반 운영
            </li>
            <li>
              <span class="bullet-dot"></span>
              현재 페이지에서 바로 시작
            </li>
          </ul>
          <span class="selector-card__btn selector-card__btn--gold">
            광고주로 시작하기
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </span>
        </button>

        <!-- Card 3: 티블 공동구매 (For Sales) -->
        <a
          href="https://commerce.3alliance.co.kr/"
          class="selector-card selector-card--sales"
          data-testid="selector-card-commerce"
          @click="trackGroupBuy"
        >
          <div class="selector-card__icon selector-card__icon--white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M16 10a4 4 0 0 1-8 0" />
              <path d="M3.103 6.034h17.794" />
              <path
                d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"
              />
            </svg>
          </div>
          <span class="selector-card__subtitle selector-card__subtitle--gray"
            >FOR SALES</span
          >
          <h2 class="selector-card__title">티블 공동구매</h2>
          <p class="selector-card__desc">
            우리 브랜드에 맞는 셀러와 공동구매를 시작해보세요.
          </p>
          <ul class="selector-card__bullets">
            <li>
              <span class="bullet-dot"></span>
              공동구매 RS기반 무료매칭
            </li>
            <li>
              <span class="bullet-dot"></span>
              인스타그램 셀러풀 10만
            </li>
            <li>
              <span class="bullet-dot"></span>
              커머스 전문 유튜브PPL
            </li>
          </ul>
          <span class="selector-card__btn selector-card__btn--outline">
            공동구매 상담받기
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M15 3h6v6" />
              <path d="M10 14 21 3" />
              <path
                d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
/* global defineEmits */
const emit = defineEmits(['select-tble-biz']);

const trackExperience = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_service',
    service_name: 'experience',
    button_location: 'home_overlay',
  });
};

const trackGroupBuy = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_service',
    service_name: 'group_buy',
    button_location: 'home_overlay',
  });
};

const goToTbleBiz = () => {
  try {
    sessionStorage.setItem('selected_service', 'biz');
    sessionStorage.setItem('tble_biz_selected', 'true');
  } catch (e) {
    console.error('Failed to save to sessionStorage:', e);
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_service',
    service_name: 'biz',
    button_location: 'home_overlay',
  });
  emit('select-tble-biz');
};
</script>

<style scoped lang="scss">
.selector-page {
  position: fixed;
  inset: 0;
  z-index: 300;
  overflow-y: auto;
  background-color: #f7f7f7;
  padding: 32px 16px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 48px 24px;
  }
}

.selector-container {
  margin: 0 auto;
  display: flex;
  min-height: calc(100vh - 64px);
  width: 100%;
  max-width: 1152px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.selector-logo {
  margin-bottom: 32px;
  height: 32px;
  width: auto;

  @media (min-width: 768px) {
    margin-bottom: 48px;
    height: 40px;
  }
}

.selector-header {
  margin-bottom: 32px;
  max-width: 672px;
  text-align: center;

  @media (min-width: 768px) {
    margin-bottom: 48px;
  }
}

.selector-badge {
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: #ca8a04; /* gold */
}

.selector-title {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
  color: #111827;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 48px;
  }
}

.selector-desc {
  margin-top: 16px;
  font-size: 16px;
  line-height: 1.6;
  color: #6b7280;

  @media (min-width: 768px) {
    font-size: 20px;
  }
}

.selector-cards {
  display: flex;
  width: 100%;
  max-width: 1024px;
  flex-direction: column;
  justify-content: center;
  gap: 16px;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 24px;
  }

  @media (min-width: 1024px) {
    gap: 32px;
  }
}

.selector-card {
  display: flex;
  min-height: 300px;
  width: 100%;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  text-align: left;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  background-color: #f9fafb;
  color: #111827;

  @media (min-width: 768px) {
    min-height: 360px;
    flex: 1;
    max-width: 340px;
    padding: 32px;
  }

  &:hover {
    transform: translateY(-4px);
    background-color: #ffffff;
  }

  /* Desktop order: Creators (1), Advertiser (2), Sales (3) */
  &--creators {
    order: 3;
    @media (min-width: 768px) {
      order: 1;
    }
  }

  &--advertiser {
    order: 1;
    background-color: #ffffff;
    border-color: #fde047; /* Yellow border highlight */
    box-shadow: 0 18px 50px rgba(242, 178, 42, 0.18);
    cursor: pointer;

    @media (min-width: 768px) {
      order: 2;
    }

    &:hover {
      border-color: #f2b22a;
    }
  }

  &--sales {
    order: 2;
    @media (min-width: 768px) {
      order: 3;
    }
  }

  &__icon {
    margin-bottom: 20px;
    display: flex;
    height: 48px;
    width: 48px;
    align-items: center;
    justify-content: center;
    border-radius: 14px;

    &--white {
      background-color: #ffffff;
      color: #ca8a04;
      border: 1px solid #f3f4f6;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    }

    &--gold {
      background-color: #f2b22a;
      color: #ffffff;
    }
  }

  &__subtitle {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;

    &--gray {
      color: #9ca3af;
    }

    &--gold {
      color: #ca8a04;
    }
  }

  &__title {
    margin-top: 0;
    margin-bottom: 12px;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.25;
    color: #111827;

    @media (min-width: 768px) {
      font-size: 28px;
    }
  }

  &__desc {
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
    color: #6b7280;

    @media (min-width: 768px) {
      font-size: 15px;
    }
  }

  &__bullets {
    margin-top: 24px;
    margin-bottom: 32px;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 12px;

    li {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: #4b5563;

      .bullet-dot {
        height: 6px;
        width: 6px;
        border-radius: 9999px;
        background-color: #f2b22a;
        flex-shrink: 0;
      }
    }
  }

  &__btn {
    margin-top: auto;
    display: inline-flex;
    height: 48px;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 700;
    transition: all 0.2s ease-in-out;
    box-sizing: border-box;

    &--outline {
      border: 1px solid #e5e7eb;
      background-color: #ffffff;
      color: #111827;

      .selector-card:hover & {
        border-color: #f2b22a;
        color: #ca8a04;
      }
    }

    &--gold {
      background-color: #f2b22a;
      color: #ffffff;
      border: none;

      .selector-card:hover & {
        background-color: #d99b1c;
      }
    }
  }
}
</style>
